export const formatDate = (date) => {
    const newDate = new Date(date)
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    const time = newDate.toLocaleTimeString('en-US')
    const localeDate =  newDate.toLocaleString('en-TT', options).split(" ");
    const number = localeDate[1] < 10 ? `0${localeDate[1]}` : localeDate[1];
    return newDate instanceof Date && !isNaN(newDate.valueOf()) ? `${localeDate[2]} ${number}, ${localeDate[3]} ${time}` :  date;
};

  